import { List } from 'antd';
import styled from 'styled-components';

export const StyledList = styled(List)`
  .image-tag-item {
    padding: ${({ theme: { token } }) => token.paddingXS}px 0;

    .image-tag-meta {
      align-items: center !important;

      .image-tag-avatar {
        background: ${({ theme: { token } }) => token.colorPrimaryBg};
      }

      .image-tag-title {
        margin: 0;
        color: ${({ theme: { token } }) => token.colorTextHeading};
        font-size: ${({ theme: { token } }) => token.headerFontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
        line-height: ${({ theme: { token } }) => token.lineHeightLG};
      }
    }
  }
`;
